// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';

import HomePage from './routes/home';
import JobPosts from './routes/jobs';
import ErrorPage from './routes/error-page';
import RegistrationPage from './routes/registration';
import JobDetailPage from './routes/jobDetailsPage';
import { BlogViewComponent } from './routes/blogs';
import './tailwind.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<HomePage />} />
				{/* BLOGS */}
				<Route path="/blogs" element={<BlogViewComponent single={false} />} />
				<Route path="/blog/:blogId" element={<BlogViewComponent single={true} />} />

				{/* JOB POST */}
				<Route path="/jobs" element={<JobPosts />} />
				<Route path="/jobs/:jobId" element={<JobDetailPage />} />
				<Route path="/apply" element={<RegistrationPage />} />

				{/* UTILS */}
				<Route path="/contact" element={<BlogViewComponent single={false} />} />
				<Route path="/about" element={<BlogViewComponent single={false} />} />
				<Route path="/social" element={<BlogViewComponent single={false} />} />
				<Route path="/privacy-policy" element={<BlogViewComponent single={false} />} />

				<Route path="/404-not-found" element={<ErrorPage />} />
				<Route path="*" element={<HomePage />} />
			</Routes>
		</BrowserRouter>
	);
}
